/* Startseite: ruhige Bewegung. Respektiert «Bewegung reduzieren»; ohne JS bleibt alles sichtbar. */
(() => {
  /* Stimmen: eine grosse Stimme, Wechsel von Hand (kein automatisches Rotieren) */
  document.querySelectorAll('[data-gft-stimmen]').forEach(grid => {
    const figs = [...grid.querySelectorAll(':scope > figure')];
    const nav = grid.parentElement.querySelector('.ds-stimmen__nav');
    if (figs.length < 2 || !nav) return;
    grid.classList.add('is-single'); nav.hidden = false;
    let aktiv = 0;
    const show = (i, richtung = 0) => {
      aktiv = (i + figs.length) % figs.length;
      figs.forEach((f, j) => { f.hidden = j !== aktiv; });
      nav.querySelectorAll('button').forEach((b, j) => b.setAttribute('aria-pressed', j === aktiv ? 'true' : 'false'));
      if (richtung && figs[aktiv].animate && !matchMedia('(prefers-reduced-motion: reduce)').matches)
        figs[aktiv].animate([{ opacity: 0, transform: `translateX(${richtung * 40}px)` }, { opacity: 1, transform: 'none' }], { duration: 280, easing: 'ease-out' });
    };
    nav.addEventListener('click', e => { const b = e.target.closest('button[data-stimme]'); if (b) { const i = Number(b.dataset.stimme); if (i !== aktiv) show(i, i > aktiv ? 1 : -1); } });
    /* Wischen (Handy): nach links nächste, nach rechts vorherige Stimme; senkrechtes Scrollen bleibt frei */
    let x0 = null, y0 = 0;
    grid.addEventListener('touchstart', e => { if (e.touches.length === 1) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; } else x0 = null; }, { passive: true });
    grid.addEventListener('touchcancel', () => { x0 = null; }, { passive: true });
    grid.addEventListener('touchend', e => {
      if (x0 === null) return;
      const t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0; x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) show(aktiv + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
    }, { passive: true });
    show(0);
  });
  /* Anwendung: immer nur ein Bereich offen (Fallback, falls der Browser details[name] nicht kennt) */
  document.querySelectorAll('details.gft-usecase').forEach(d => d.addEventListener('toggle', () => {
    if (!d.open) return;
    d.parentElement.querySelectorAll('details.gft-usecase[open]').forEach(o => { if (o !== d) o.open = false; });
  }));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = document.documentElement;

  /* Spendenzahl zählt einmal hoch, sobald sie sichtbar wird */
  const counters = document.querySelectorAll('[data-gft-count]');
  const format = n => String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '’');
  const run = el => {
    const target = Number(el.dataset.gftCount);
    if (!target || reduce) { el.textContent = format(target); return; }
    const start = performance.now(), dur = 1800;
    const step = now => {
      const t = Math.min(1, (now - start) / dur), eased = 1 - Math.pow(1 - t, 3);
      el.textContent = format(target * eased);
      if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  if (counters.length) {
    const io = new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } }), { threshold: .6 });
    counters.forEach(el => { if (!reduce) el.textContent = '0'; io.observe(el); });
  }

  if (reduce) { document.querySelectorAll('.gft-stage video').forEach(v => { v.pause(); v.removeAttribute('autoplay'); }); return; }
  root.classList.add('gft-motion');

  /* Erscheinen beim Scrollen, gruppenweise leicht versetzt */
  const groups = [
    '.gft-selection h2', '.gft-set',
    '.ds-stimmen h2', '.ds-stimmen blockquote, .ds-stimmen article, .ds-stimmen figure',
    '.gft-voice-one__image', '.gft-voice-one blockquote',
    '.gft-origin h2', '.gft-origin__text',
    '.gft-impact__content',
    '.ds-animal', '.gft-film h2', '.gft-film__media',
    '.gft-home-usecases h2', '.gft-more h2', '.gft-more li', '.ed-article, .gft-journal article', '.ds-faq h2'
  ];
  const items = [];
  groups.forEach(sel => document.querySelectorAll('#MainContent ' + sel).forEach((el, i) => {
    if (el.closest('.gft-stage') || el.closest('[data-gft-stimmen] > [hidden]') || el.classList.contains('gft-reveal')) return;
    el.classList.add('gft-reveal'); el.style.setProperty('--reveal-delay', Math.min(i, 5) * 0.08 + 's'); items.push(el);
  }));
  const rio = new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: .12 });
  items.forEach(el => rio.observe(el));

  /* Bühne: das Bild bewegt sich etwas langsamer als die Seite */
  const media = document.querySelector('.gft-stage__media');
  if (media) {
    let ticking = false;
    const move = () => { ticking = false; const y = Math.min(window.scrollY, 900); media.style.transform = `translate3d(0, ${y * 0.18}px, 0) scale(${1.06 - Math.min(y, 600) / 10000})`; };
    move();
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(move); } }, { passive: true });
  }

  /* Karten zum Anfassen: neigen sich zum Zeiger (nur Maus/Trackpad) */
  if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('.ds-animal__knopf').forEach(card => {
      card.addEventListener('pointermove', e => {
        const r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        card.classList.add('is-tilting');
        card.style.transform = `perspective(700px) rotateY(${x * 14}deg) rotateX(${-y * 12}deg) translateY(-6px)`;
      });
      card.addEventListener('pointerleave', () => { card.classList.remove('is-tilting'); card.style.transform = ''; });
    });
  }

  /* Hintergrundvideo der Bühne pausieren, wenn es nicht sichtbar ist */
  const video = document.querySelector('.gft-stage video');
  if (video) new IntersectionObserver(([e]) => { e.isIntersecting ? video.play().catch(() => {}) : video.pause(); }).observe(video);
})();
